import { useProductWishList } from '@src/hooks/useProductWishlist'
import { IconButton } from '@src/quince-components/src'
import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import { FC, SyntheticEvent } from 'react'

import DeleteIcon from '../../icons/delete.inline.svg'
import { CardVariant } from '../../product-card.types'

import styles from './delete-wishlist.module.scss'

export const ProductCardDeleteFromWishlist: FC<{
  shopifyProductId: string | number
  selectedCardVariant?: CardVariant
  deleteItemClassName?: string
  wishlistTrackingConfig: Record<string, unknown>
}> = props => {
  const { t } = useTranslation('common')
  const selectedColor = props.selectedCardVariant?.displayConfig.value

  const { removeItemFromWishList } = useProductWishList()

  const onWishListToggle = (event: SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()

    removeItemFromWishList(props.shopifyProductId as number, selectedColor ?? '', props.wishlistTrackingConfig).catch(
      (e: unknown) => {
        console.error(e)
      },
    )
  }

  return (
    <IconButton
      className={classnames(props.deleteItemClassName, styles.defaultButton)}
      iconClassName={classnames(styles.icon)}
      iconSvg={DeleteIcon}
      onClick={onWishListToggle}
      ariaLabel={t('remove_from_wishlist')}
    />
  )
}
